import { render } from "./FridgeDetailsCoolingAssistSettingsItem.vue?vue&type=template&id=44d582c8&scoped=true&ts=true"
import script from "./FridgeDetailsCoolingAssistSettingsItem.vue?vue&type=script&lang=ts"
export * from "./FridgeDetailsCoolingAssistSettingsItem.vue?vue&type=script&lang=ts"

import "./FridgeDetailsCoolingAssistSettingsItem.vue?vue&type=style&index=0&id=44d582c8&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d582c8"]])

export default __exports__